import { useState } from "react";
import { BellRing, CheckCircle2 } from "lucide-react";
import { api, apiError } from "@/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";

export function SubscribeCard({ event }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [sending, setSending] = useState(false);

  async function submit(submitEvent) {
    submitEvent.preventDefault();
    setSending(true);
    try {
      const response = await api.post(`/events/${event.slug}/subscribe`, { email });
      setDone(true);
      toast.success(response.data.status === "already_subscribed" ? "You're already on the list" : "You're on the list");
    } catch (error) {
      toast.error(apiError(error, "Could not save your email"));
    } finally {
      setSending(false);
    }
  }

  return (
    <section data-testid="subscribe-card" className="border border-gold/25 bg-carbon/80 p-6 sm:p-8">
      <div className="grid gap-6 md:grid-cols-[1.2fr_1fr] md:items-center">
        <div>
          <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.32em] text-gold"><BellRing className="h-4 w-4" /> Photo drop alerts</p>
          <h2 className="mt-3 font-display text-3xl font-light text-white">More frames still processing?</h2>
          <p className="mt-3 max-w-lg text-sm leading-7 text-zinc-500">Leave your email and we will send one message the moment new photos from {event.title} go live — including any attendee-only offer.</p>
        </div>
        {done ? (
          <div data-testid="subscribe-success" className="flex items-center gap-3 border border-gold/40 bg-gold/10 p-5">
            <CheckCircle2 className="h-5 w-5 shrink-0 text-gold" />
            <p className="text-sm text-zinc-300">You are on the list. Watch your inbox — one email, only when the photos drop.</p>
          </div>
        ) : (
          <form data-testid="subscribe-form" onSubmit={submit} className="flex flex-col gap-3 sm:flex-row">
            <Input data-testid="subscribe-email-input" required type="email" value={email} onChange={(changeEvent) => setEmail(changeEvent.target.value)} placeholder="you@email.com" className="h-12 border-white/10 bg-white/[0.03] text-white placeholder:text-zinc-600" />
            <Button data-testid="subscribe-submit-button" disabled={sending} className="h-12 shrink-0 rounded-none bg-gold px-6 font-mono text-xs uppercase tracking-[0.22em] text-onyx hover:bg-titanium">
              {sending ? "Joining" : "Notify me"}
            </Button>
          </form>
        )}
      </div>
    </section>
  );
}
